import React, { useState, useEffect, memo } from 'react';
import Singleton from '../../../core/singleton';
import AxiosServices from '../../../services/AxiosServices';
import Spinner from '../../../ui/img/spinner.svg';

const EnableOrDisableOnBoardSales = props => {
    const [notification, setNotification] = useState("send_default_notification");
    const [customNotification, setCustomNotification] = useState('');
    const [shopMetrics, setShopMetrics] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    /** trigger an event when the select tag is used */
    const onOptionChange = select => setNotification(select.target.value);
    /** perform a request ajax to set the shop metrics */
    const getShopMetrics = () => {
        AxiosServices.getShopStats(props.shop.uuid).then((metrics) => setShopMetrics(metrics.data))
    }
    const SubmitButton = () => <div className="modal-footer">
        <button
            type="submit"
            disabled={((customNotification === "") && (notification === "send_custom_notification")) ? true : false}
            className="btn btn-success btn-block validateStockModification">{Singleton.getInstance().getTradByKey('confirm')}</button>
    </div>
    /** once the form is submited, send the respoonse via an ajax call */
    const onFormSubmit = form => {
        form.preventDefault();
        setIsSubmitting(true);
        let isOpen = (props.shop.status === "open");
        let status = isOpen ? "closed" : "open";
        let open_message = (props.shop.locales.length > 0) ? props.shop.locales[0].open_message : "open_message";
        let close_message = (props.shop.locales.length > 0) ? props.shop.locales[0].close_message : "close_message";
        let message = (notification === "send_custom_notification") ? customNotification :
            isOpen ? close_message : open_message;
        let title = (props.shop.locales.length > 0) ? props.shop.locales[0].title : "title";
        let content_role_id = (props.shop.links.length > 0) ? props.shop.links[0].content_role.id : "content_role_id";
        let content_uuid = (props.shop.links.length > 0) ? props.shop.links[0].content_uuid : "content_uuid";
        let content_role_uuid = Singleton.getInstance().content_roles.find((content_role) => (content_role.id === Number(content_role_id))).uuid;
        let c = {
            "locales": [
                {
                    "locale": "en",
                    "is_default": true,
                    "title": title,
                    "message": message
                }
            ],
            "timeout_seconds": 10,
            "content_link": {
                "content_role": content_role_uuid,
                "content_uuid": content_uuid
            }
        };
        AxiosServices.putShopStatus(props.shop.uuid, status)
            .then(() => {
                (notification === "do_not_passengers")
                    ? props.close()
                    : AxiosServices.pushNotification(c).then(() => props.close());
            })
            .catch(err => {
                console.log(err);
            });
    }
    /** like a component did mount */
    useEffect(() => {
        if (props.shop.status === "open")
            getShopMetrics();
    }, []);
    return <form onSubmit={onFormSubmit}>
        <fieldset disabled={isSubmitting}>
            <div className="modal-header">
                <h5 className="modal-title">
                    {props.shop.usual_name}&nbsp;
                {
                        (shopMetrics === null && (props.shop.status === "open")) &&
                        <img src={Spinner} width="50"></img>
                    }
                    {
                        ((shopMetrics !== null)) &&
                        <>
                            <span className='badge badge-warning'>
                                <i className="fas fa-shopping-basket"></i>:  {shopMetrics.carts.awaiting}
                            </span>&nbsp;
                        <span className='badge badge-warning'>
                                <i className="fas fa-dolly-flatbed"></i>:  {shopMetrics.orders.awaiting}
                            </span>
                        </>
                    }
                </h5>
                <button onClick={props.close} type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                {
                    props.children
                }

                <div className="form-group">
                    <select className="form-control" onChange={onOptionChange}>
                        <option value="send_default_notification">
                            {Singleton.getInstance().getTradByKey('send_default_notification')}
                        </option>
                        <option value="send_custom_notification">
                            {Singleton.getInstance().getTradByKey('send_custom_notification')}
                        </option>
                        <option value="do_not_passengers">
                            {Singleton.getInstance().getTradByKey('do_not_passengers')}
                        </option>
                    </select>
                </div>
                {
                    (notification === "send_custom_notification") &&
                    <div>
                        <label htmlFor="notificationCustomMessage">{Singleton.getInstance().getTradByKey('custom_notification')}</label>
                        <textarea maxLength="250" minLength="1" value={customNotification} onChange={(e) => setCustomNotification(e.target.value)} className="form-control" id="notificationCustomMessage" rows="3"></textarea>
                        <span className={"badge badge-light"}>{customNotification.length}/250</span>
                    </div>
                }
            </div>
            <SubmitButton />
        </fieldset>
    </form>
}
export default memo(EnableOrDisableOnBoardSales);